// @module Eureka.MaxaPartPicker.MaxaPartPicker
define('PartPickerSort'
    , [
        'partspickersort.tpl'

        , 'Eureka.MaxaPartPicker.MaxaPartPicker.SS2Model'
        , 'Eureka.MaxaPartPicker.MaxaPartPicker.Model'

        , 'Backbone'
    ]
    , function (
        partpickersort_tpl
        , MaxaPartPickerSS2Model
        , MaxaPartPickerModel
        , Backbone
    ) {
        'use strict';

        // @class Eureka.MaxaPartPicker.MaxaPartPicker.View @extends Backbone.View
        return Backbone.View.extend({

            template: partpickersort_tpl

            , initialize: function (options) {
                console.log({options});
                this.is_logged_in = options.is_logged_in;
            }

            , events: {
                'change [data-action="sort_items"]': 'itemSort',
                'change [data-action="in-stock"]': 'inStock'

            }

            , bindings: {}

            , childViews: {}

            , inStock: function inStock(e){
                let params = new URLSearchParams(window.location.hash.substr(1))
                params.set("instock", e.currentTarget.checked)
                params.delete("page")
                window.location.href = window.location.pathname + "#" + params.toString()
            }

            , itemSort: function itemSort(e){
                for(var i=0; i < e.currentTarget.length; i++){
                    if(e.currentTarget[i].selected === true) {
                        let params = new URLSearchParams(window.location.hash.substr(1))

                        params.set("sortby", e.currentTarget[i].value)

                        params.delete("page")
                        window.location.href = window.location.pathname + "#" + params.toString()

                    }
                }
            }


            //@method getContext @return Eureka.MaxaPartPicker.MaxaPartPicker.View.Context
            , getContext: function getContext() {
                let hash = window.location.hash.substr(1);
                let hashSplit = hash.split('&').reduce(function (res, item) {
                    let parts = item.split('=');
                    res[parts[0]] = parts[1];
                    return res;
                }, {});
                let options = [
                    {name: 'Most Popular', eventName: "most-popular"},
                    {name: "Price low to high", eventName: "low-to-high"},
                    {name: "Price high to low", eventName: "high-to-low"},
                    {name: "A to Z", eventName: "atoz"},
                    {name: "Z to A", eventName: "ztoa"}
                ]

                if(hashSplit.sortby){
                    for(let i=0; i < options.length; i++){
                        if(options[i].eventName === hashSplit.sortby){
                            options[i].isSelected = true
                            break;
                        }
                    }
                }
                let inStock = (hashSplit.instock === "true")
                return {
                    options: options,
                    inStock: inStock,
                    loggedIn: this.is_logged_in
                };
            }
        });
    });
